import { IProject } from 'models';
import { Renderer } from 'rewild-renderer';
import { registerChunkSnapshotDevCommands } from './ChunkSnapshotDevCommands';
import { registerRenderQualityCommands } from './RenderQualityCommands';
import { registerShadowDebugCommands } from './ShadowDebugCommands';
import { registerAoDebugCommands } from './AoDebugCommands';
import { registerSceneDebugCommands } from './SceneDebugCommands';
import { registerSkyDebugCommands } from './SkyDebugCommands';
import { registerAtmosphereDebugCommands } from './AtmosphereDebugCommands';
import { registerPbrHarnessCommands } from './PbrHarnessCommands';
import { registerGltfImportCommands } from './GltfImportCommands';
import { registerLakeDebugCommands } from './LakeDebugCommands';
import { registerWaterDebugCommands } from './WaterDebugCommands';
import { registerWaterEditDevCommands } from './WaterEditDevCommands';
import { registerPlayerDebugCommands } from './PlayerDebugCommands';
import { registerTerrainDebugCommands } from './TerrainDebugCommands';
import {
  registerScatterDebugCommands,
  registerWindDebugCommands,
} from './ScatterDebugCommands';

// One-stop registration for the window console commands, called wherever a
// renderer is bound to a loaded project (editor sync + game load). Commands
// close over the given renderer/project, so re-registering on a later load
// simply repoints them.
export function registerDebugCommands(renderer: Renderer, project: IProject) {
  registerRenderQualityCommands(renderer);
  registerSceneDebugCommands(renderer);
  registerSkyDebugCommands(renderer);
  registerAtmosphereDebugCommands(renderer);
  registerShadowDebugCommands(renderer);
  registerAoDebugCommands(renderer);
  registerPbrHarnessCommands(renderer);
  registerGltfImportCommands(renderer);
  registerScatterDebugCommands(renderer);
  registerWindDebugCommands(renderer);
  registerLakeDebugCommands(renderer);
  registerWaterDebugCommands(renderer);
  registerWaterEditDevCommands(renderer, project);
  registerChunkSnapshotDevCommands(renderer, project);
  registerTerrainDebugCommands(renderer);
  registerPlayerDebugCommands();
}
